import RequestAbstract from "./RequestAbstract";

/**
 * Thumbnail sizes we ask the server for. SMALL suits list rows and the
 * composer strip; PREVIEW is meant for the post preview, whose media box is
 * ~523 CSS px and therefore ~1046 device px on a 2× screen.
 */
export const THUMB_SIZE = {
  SMALL: 300,
  PREVIEW: 1080,
};

export default class Files extends RequestAbstract {
  get link() {
    return this.links.files;
  }

  get thumbnailLink() {
    return this.link + "/thumbnail/";
  }
  get downloadLink() {
    return this.link + "/download/";
  }

  async getAll() {
    return await super.getAll(this.getSortField("created_at"));
  }

  async upload(parentId, files) {
    return await this.postFormData(
      this.link + "/upload/" + (parentId || 0),
      { files },
      false,
    );
  }

  async thumbnail(id) {
    return await this.post(this.thumbnailLink + id + "/300");
  }

  async download(id) {
    return await this.post(this.downloadLink + id);
  }

  /**
   * URL for a file, as a thumbnail of the requested size by default.
   *
   * The size matters: the server renders and caches one asset per size
   * (immutable), so asking for 300 and painting it into a 523px box — which is
   * what every preview used to do — is a 1.74× upscale, worse on a retina
   * screen. Callers pass the size they will actually render at.
   *
   * @param {number|string} id - File id.
   * @param {boolean} linkToThumb - Thumbnail (default) or the original file.
   * @param {number} size - Thumbnail size in pixels.
   * @returns {string} Absolute URL.
   */
  formLink(id, linkToThumb = true, size = THUMB_SIZE.SMALL) {
    const link = linkToThumb ? "thumbnailLink" : "downloadLink";
    const end = linkToThumb ? `/${size}` : "";

    return this.getFullLink(this[link] + id + end);
  }
}
